"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PREFIX = void 0;

var React = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _card = _interopRequireDefault(require("../card"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

var cx = _bind["default"].bind(_style["default"]);

var PREFIX = 'xsui-card-with-image';
exports.PREFIX = PREFIX;

var CardBanner = function CardBanner(_ref) {
  var image = _ref.image,
      badge = _ref.badge,
      children = _ref.children,
      footer = _ref.footer,
      className = _ref.className,
      cardDataId = _ref.cardDataId,
      badgeDataId = _ref.badgeDataId,
      imageDataId = _ref.imageDataId;
  return /*#__PURE__*/_jsx(_card["default"], {
    className: className,
    dataId: cardDataId
  }, void 0, function () {
    return /*#__PURE__*/_jsx("div", {
      className: cx(PREFIX)
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: cx("".concat(PREFIX, "__body"))
    }, void 0, /*#__PURE__*/_jsx("img", {
      src: image,
      className: cx("".concat(PREFIX, "__image")),
      "data-id": imageDataId,
      alt: ""
    }), badge && /*#__PURE__*/_jsx("div", {
      className: cx("".concat(PREFIX, "__badge")),
      "data-id": badgeDataId
    }, void 0, badge), children), footer && footer);
  });
};

var _default = CardBanner;
exports["default"] = _default;